import { format, isValid, parseISO } from "date-fns"
import { ptBR } from "date-fns/locale"

function parseDateValue(value: string | Date | null | undefined): Date | null {
  if (!value) return null

  if (value instanceof Date) {
    return isValid(value) ? value : null
  }

  const parsed = parseISO(value)
  return isValid(parsed) ? parsed : null
}

export function formatDate(value: string | Date | null | undefined, fallback = "-"): string {
  const parsed = parseDateValue(value)
  if (!parsed) return fallback

  return format(parsed, "dd/MM/yyyy", { locale: ptBR })
}

export function formatDateTime(value: string | Date | null | undefined, fallback = "-"): string {
  const parsed = parseDateValue(value)
  if (!parsed) return fallback

  return format(parsed, "dd/MM/yyyy HH:mm", { locale: ptBR })
}

export function toDateInputValue(value: Date = new Date()): string {
  return format(value, "yyyy-MM-dd")
}

